<template>
  <div>
    <router-link to="/">
      <img class="logo" src="/static/404/logo.png">
    </router-link>
    <img src="/static/404/404.png" alt="" class="notfound">
    <p class="tips">{{$t('global.很抱歉')}}！{{$t('global.你访问的页面不存在')}}</p>
    <p class="reason">{{$t('global.输入的地址有误或该地址已被删除')}}</p>
    <router-link tag="span" to="/" class="backHome">{{$t('global.返回首页')}}</router-link>
  </div>
</template>

<script>
  import MainLayout from "@/layouts/MainLayout"

  export default {
    metaInfo() {
    return {
      title: this.$t("global.页面未找到") + " | MANA"
    };
  },
    components: {
      MainLayout
    }
  }
</script>

<style lang="stylus" scoped>
.logo{
  display: inline-block;
  width: 1.6rem;
  height: 0.4rem;
  margin-left: 1.7rem;
  margin-top: .5rem;
}
.notfound{
  display: block;
  width: 12.6rem;
  height: 6.5rem;
  margin: .5rem auto 0;
}
.tips{
  font-size: .47rem;
  font-weight: bold;
  margin-top: .4rem;
  text-align: center;
}
.reason {
  font-size: .2rem;
  text-align: center;
  margin-top: .08rem; 
}
.backHome{
  display: block;
  width: 2.4rem;
  height: .63rem;
  background: #356cfd;
  color: #fff;
  font-size: .24rem;
  text-align: center;
  line-height: .63rem;
  border-radius: .2rem;
  cursor: pointer;
  margin: .7rem auto 0;
}
</style>




// WEBPACK FOOTER //
// src/pages/error/404.vue